import { render, staticRenderFns } from "./TypePropertyList.vue?vue&type=template&id=58bd0d2b&scoped=true"
import script from "./TypePropertyList.vue?vue&type=script&lang=js"
export * from "./TypePropertyList.vue?vue&type=script&lang=js"
import style0 from "./TypePropertyList.vue?vue&type=style&index=0&id=58bd0d2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bd0d2b",
  null
  
)

export default component.exports